import classes from "./Preview.module.css";
import {useContext, useEffect, useRef} from "react";
import QRCodeStyleViewContext from "../QRCodeStyleViewContext";
import SaveButton from "./save-button/SaveButton";

function Preview() {
    /**
     * Ref to the \<div class="container"/>
     * @author Kacper Faber
     * @since 0.1.9
    */
    const containerRef = useRef<HTMLDivElement | null>(null);

    /**
     * QRCodeStyleViewContext
     * @author Kacper Faber
     * @since 0.1.9
    */
    const ctx = useContext(QRCodeStyleViewContext);

    /**
     * Reload the preview when payload is changed.
     * Does nothing, if containerRef is null
     * @author Kacper Faber
     * @since 0.1.9
    */
    const reload = () => {
        if (!containerRef.current) {
            return;
        }

        // noinspection JSSuspiciousNameCombination
        const styling = ctx.render({
            width: containerRef.current.clientWidth,
            height: containerRef.current.clientWidth,
        });

        containerRef.current.innerHTML = '';
        styling.append(containerRef.current);
    };

    useEffect(reload, [ctx.payload, ctx.style]);

    return (
        <div className={classes.root}>
            { ctx.payload ? <div
                ref={containerRef}
                className={classes.container}
            /> : null}

            <SaveButton/>
        </div>
    );
}

export default Preview;